// extracted by mini-css-extract-plugin
export var connectionButton = "_a6-1";
export var rightPanel = "_a6-3";
export var stepDescription = "_a6-2";
export var stepIcon = "_a6-0";